/**
 * Checks if a condition is met and throws an error if it is not.
 *
 * @param {boolean} condition - The condition to check.
 * @param {string} [message="Invariant failed"] - The error message to throw if the condition is not met.
 * @throws {Error} Throws an error with the provided message if the condition is false.
 */
export function invariant(condition, message = 'Invariant failed') {
  if (!condition) {
    throw new Error(message)
  }
}
